import { type GraphqlErrorCode } from '@/apollo/types/GraphqlErrorCode';

// Errors a screen plans for and explains itself: a deleted intervention, a name
// already used, an action the member may not do, a rate limit reached (its
// message says to wait). Anything else is unexpected.
export const EXPECTED_GRAPHQL_ERROR_CODES: readonly GraphqlErrorCode[] = [
  'NOT_FOUND',
  'FORBIDDEN',
  'CONFLICT',
  'BAD_USER_INPUT',
  'TOO_MANY_REQUESTS',
];
